/** html2canvas 오프스크린 캡처용 — A4 전용 주간학습 안내 */
export const WEEKLY_LEARNING_GUIDE_A4_CAPTURE_CSS = `
.cp-weekly-learning-guide-a4-sheet {
  width: 210mm;
  height: 297mm;
  min-height: 297mm;
  max-height: 297mm;
  box-sizing: border-box;
  padding: 8mm;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Noto Sans KR', sans-serif;
  overflow: hidden;
}
.cp-weekly-learning-guide-a4-sheet--neis-grid {
  padding: 6mm;
}
.cp-weekly-learning-guide-neis-legend {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 10px;
}
.cp-weekly-learning-guide-neis-legend li {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
}
.cp-weekly-learning-guide-neis-legend-swatch {
  width: 3mm;
  height: 3mm;
  border-radius: 0.4mm;
  flex-shrink: 0;
  box-sizing: border-box;
}
.cp-weekly-learning-guide-neis-legend-swatch--diff-track {
  background: #e2e2e9;
  border: 0.2mm solid #9e9e9e;
}
.cp-weekly-learning-guide-neis-legend-swatch--dedicated-mismatch {
  background: #fff6cc;
  border: 0.2mm solid #c9b86a;
}
.cp-weekly-learning-guide-neis-legend-swatch--short-edge {
  background: transparent;
  border: 0.35mm solid #27712d;
}
.cp-weekly-learning-guide-neis-legend-sample-text {
  color: #d32f2f;
  font-weight: 700;
}
.cp-weekly-learning-guide-neis-cell-stack {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.2mm;
  line-height: 1.12;
  width: 100%;
}
.cp-weekly-learning-guide-neis-dedicated-label {
  font-size: 0.68em;
  font-weight: 500;
  color: #888888;
}
.cp-weekly-learning-guide-neis-legend--a4-export {
  flex: 0 0 auto;
  margin: 0 0 2mm;
  padding: 0 0 1.5mm;
  border-bottom: 0.3mm solid #d8d8de;
  font-size: 7pt;
  line-height: 1.35;
  color: #666666;
  gap: 4px 10px;
}
.cp-weekly-learning-guide-neis-legend--a4-export .cp-weekly-learning-guide-neis-legend-swatch {
  width: 3mm;
  height: 3mm;
  border-radius: 0.4mm;
}
.cp-weekly-learning-guide-neis-legend--a4-export .cp-weekly-learning-guide-neis-legend-swatch--diff-track {
  background: #e2e2e9;
  border: 0.2mm solid #9e9e9e;
}
.cp-weekly-learning-guide-neis-legend--a4-export .cp-weekly-learning-guide-neis-legend-swatch--dedicated-mismatch {
  background: #fff6cc;
  border: 0.2mm solid #c9b86a;
}
.cp-weekly-learning-guide-neis-legend--a4-export .cp-weekly-learning-guide-neis-legend-swatch--short-edge {
  border: 0.35mm solid #27712d;
}
.cp-weekly-learning-guide-neis-legend--a4-export .cp-weekly-learning-guide-neis-legend-sample-text {
  color: #d32f2f;
  font-weight: 700;
}
.cp-weekly-learning-guide-a4-neis-grid {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
}
.cp-weekly-learning-guide-a4-neis-grid-col {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: 4mm;
}
.cp-weekly-learning-guide-a4-neis-grid-column-divider {
  flex: 0 0 7mm;
  width: 7mm;
  align-self: stretch;
  background-image: repeating-linear-gradient(
    to bottom,
    #8b8d96 0,
    #8b8d96 5px,
    transparent 5px,
    transparent 10px
  );
  background-position: center center;
  background-size: 1.5px 10px;
  background-repeat: repeat-y;
  pointer-events: none;
}
.cp-weekly-learning-guide-a4-neis-grid-cell {
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  min-width: 0;
  overflow: hidden;
  padding-bottom: 2mm;
  box-sizing: border-box;
}
.cp-weekly-learning-guide-a4-neis-grid-col > .cp-weekly-learning-guide-a4-neis-grid-cell:last-child {
  padding-bottom: 0;
}
.cp-weekly-learning-guide-a4-neis-grid-week-title {
  margin: 0 0 1mm;
  font-size: var(--wlg-a4-grid-title-font, 9pt) !important;
  font-weight: 700;
  text-align: center;
  line-height: 1.2;
  flex-shrink: 0;
  word-break: keep-all;
}
.cp-weekly-learning-guide-a4-table-wrap--grid {
  flex: 0 0 auto;
  min-height: 0;
}
.cp-weekly-learning-guide-a4-table-wrap--grid .cp-weekly-learning-guide-a4-table {
  height: auto !important;
}
.cp-weekly-learning-guide-a4-title {
  flex-shrink: 0;
  text-align: center;
  margin: 0 0 2mm;
}
.cp-weekly-learning-guide-a4-title-line1 {
  margin: 0;
  font-size: var(--wlg-a4-title-font, 20pt) !important;
  font-weight: 700;
  line-height: 1.3 !important;
  word-break: keep-all;
}
.cp-weekly-learning-guide-a4-title-line2 {
  margin: 1mm 0 0;
  font-size: var(--wlg-a4-title2-font, 14pt) !important;
  font-weight: 700;
  line-height: 1.25 !important;
}
.cp-weekly-learning-guide-a4-table-wrap {
  flex: 1 1 auto;
  min-height: 0;
  overflow: visible !important;
  background: #ffffff;
}
.cp-weekly-learning-guide-a4-table {
  --wlg-edge-color: #8b8d96;
  --wlg-edge-width: 1.5px;
  --wlg-title-bg: #e8e8eb;
  width: 100%;
  height: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  border: var(--wlg-edge-width) solid var(--wlg-edge-color);
  background: #ffffff;
}
.cp-weekly-learning-guide-a4-table th,
.cp-weekly-learning-guide-a4-table td {
  border: 1px solid #d8dde4;
  padding: 0.4mm 1mm;
  font-size: var(--wlg-a4-cell-font, 9pt) !important;
  line-height: 1.14;
  white-space: pre-wrap;
  word-break: break-word;
  vertical-align: middle;
}
.cp-weekly-learning-guide-a4-table thead tr:first-child th,
.cp-weekly-learning-guide-a4-table thead tr:first-child td {
  border-bottom: var(--wlg-edge-width) solid var(--wlg-edge-color);
}
.cp-weekly-learning-guide-a4-table thead tr:last-child th,
.cp-weekly-learning-guide-a4-table thead tr:last-child td {
  border-bottom: var(--wlg-edge-width) solid var(--wlg-edge-color);
}
.cp-weekly-learning-guide-a4-table thead .cp-weekly-learning-guide-a4-title-col {
  border-right: var(--wlg-edge-width) solid var(--wlg-edge-color);
}
.cp-weekly-learning-guide-a4-table thead .cp-weekly-learning-guide-a4-day-head,
.cp-weekly-learning-guide-a4-table thead .cp-weekly-learning-guide-a4-date-head {
  border-right: var(--wlg-edge-width) solid var(--wlg-edge-color);
}
.cp-weekly-learning-guide-a4-period-tbody > tr:first-child > th.cp-weekly-learning-guide-a4-period-title {
  border-top: var(--wlg-edge-width) solid var(--wlg-edge-color);
  border-right: var(--wlg-edge-width) solid var(--wlg-edge-color);
  border-bottom: var(--wlg-edge-width) solid var(--wlg-edge-color);
}
.cp-weekly-learning-guide-a4-period-tbody > tr:first-child > td {
  border-top: var(--wlg-edge-width) solid var(--wlg-edge-color);
  border-right: var(--wlg-edge-width) solid var(--wlg-edge-color);
}
.cp-weekly-learning-guide-a4-period-tbody > tr:not(:first-child) > td {
  border-right: var(--wlg-edge-width) solid var(--wlg-edge-color);
}
.cp-weekly-learning-guide-a4-period-tbody > tr:last-child > td {
  border-bottom: var(--wlg-edge-width) solid var(--wlg-edge-color);
}
.cp-weekly-learning-guide-a4-notice-tbody > tr > th.cp-weekly-learning-guide-a4-period-title {
  border-right: var(--wlg-edge-width) solid var(--wlg-edge-color);
}
.cp-weekly-learning-guide-a4-title-col,
.cp-weekly-learning-guide-a4-day-head,
.cp-weekly-learning-guide-a4-date-head,
.cp-weekly-learning-guide-a4-period-title {
  background: var(--wlg-title-bg);
  font-weight: 700;
  text-align: center;
}
.cp-weekly-learning-guide-a4-title-col,
.cp-weekly-learning-guide-a4-period-title {
  width: 9%;
}
.cp-weekly-learning-guide-a4-period-title {
  font-size: var(--wlg-a4-period-font, 10.5pt) !important;
}
.cp-weekly-learning-guide-a4-cell--center { text-align: center; }
.cp-weekly-learning-guide-a4-cell--top { text-align: left; vertical-align: top; }
.cp-weekly-learning-guide-a4-cell--unit {
  background-color: #e3ddd7 !important;
  color: #141414;
}
.cp-weekly-learning-guide-a4-tr--1line > td,
.cp-weekly-learning-guide-a4-tr--1line > th.cp-weekly-learning-guide-a4-period-title {
  box-sizing: border-box;
  min-height: var(--wlg-a4-row-1line-h, 4mm);
  height: var(--wlg-a4-row-1line-h, 4mm);
  max-height: var(--wlg-a4-row-1line-h, 4mm);
  overflow: hidden;
  text-overflow: ellipsis;
}
.cp-weekly-learning-guide-a4-tr--1line > td.cp-weekly-learning-guide-a4-cell--subject-line {
  font-size: var(--wlg-a4-subject-font, 13pt) !important;
  font-weight: 700;
}
.cp-weekly-learning-guide-a4-tr--neis > td.cp-weekly-learning-guide-cell--neis-track {
  box-sizing: border-box;
  white-space: normal;
  word-break: break-word;
  vertical-align: middle;
  font-weight: 800;
  line-height: 1.2;
  height: var(--wlg-a4-row-1line-h, 4mm);
  min-height: var(--wlg-a4-row-1line-h, 4mm);
  max-height: var(--wlg-a4-row-1line-h, 4mm);
  overflow: hidden;
}
.cp-weekly-learning-guide-a4-tr--learning > td {
  height: var(--wlg-a4-row-learning-h, 12mm);
  min-height: var(--wlg-a4-row-learning-h, 12mm);
  vertical-align: top;
}
.cp-weekly-learning-guide-a4-cell-learning-inner {
  display: block;
  word-break: break-word;
  white-space: pre-wrap;
}
.cp-weekly-learning-guide-a4-notice-cell {
  text-align: left;
  vertical-align: top;
}
.cp-weekly-learning-guide-a4-tr--notice > th,
.cp-weekly-learning-guide-a4-tr--notice > td {
  box-sizing: border-box;
  height: var(--wlg-a4-notice-row-h, 28mm);
  min-height: var(--wlg-a4-notice-row-h, 28mm);
  max-height: var(--wlg-a4-notice-row-h, 28mm);
  overflow: hidden;
}
.cp-weekly-learning-guide-a4-tr--notice > th {
  vertical-align: middle;
}
.cp-weekly-learning-guide-a4-notice-text {
  white-space: pre-wrap;
  word-break: break-word;
  font-size: var(--wlg-a4-notice-font, 11.5pt) !important;
  line-height: 1.14;
}
.cp-weekly-learning-guide-cell--surface-holiday {
  background: rgba(211, 47, 47, 0.22) !important;
}
.cp-weekly-learning-guide-a4-table .cp-weekly-learning-guide-cell--neis-match-base {
  background: #ffffff !important;
}
.cp-weekly-learning-guide-a4-table .cp-weekly-learning-guide-cell--neis-diff-track {
  background: #e2e2ea !important;
}
.cp-weekly-learning-guide-a4-table .cp-weekly-learning-guide-cell--neis-dedicated-mismatch {
  background: #fff6cc !important;
}
/* html2canvas: inset box-shadow 금지 — 테두리는 인라인 border로만 */
.cp-weekly-learning-guide-a4-table td.cp-weekly-learning-guide-cell--neis-short-increase {
  box-shadow: none !important;
}
.cp-weekly-learning-guide-cell--neis-unregistered-timetable,
.cp-weekly-learning-guide-a4-table .cp-weekly-learning-guide-cell--neis-unregistered-timetable {
  color: #d32f2f !important;
  font-weight: 800;
}
.cp-weekly-learning-guide-a4-table td.cp-weekly-cell-no-class.cp-weekly-cell-unused-kind {
  background-color: #ffffff !important;
  background-image: repeating-linear-gradient(
    -45deg,
    #ffffff,
    #ffffff 2px,
    rgba(128, 128, 128, 0.12) 2px,
    rgba(128, 128, 128, 0.12) 4px
  ) !important;
}
.cp-weekly-learning-guide-a4-table td.cp-weekly-cell-activity-hatch {
  background-color: #f5f0e6 !important;
  background-image: repeating-linear-gradient(
    -45deg,
    transparent,
    transparent 2px,
    rgba(255, 255, 255, 0.72) 2px,
    rgba(255, 255, 255, 0.72) 4px
  ) !important;
}
.cp-weekly-learning-guide-a4-table td.cp-weekly-cell-calendar-non-class {
  background-color: rgba(96, 125, 139, 0.12) !important;
  background-image: repeating-linear-gradient(
    90deg,
    transparent,
    transparent 3px,
    rgba(96, 125, 139, 0.22) 3px,
    rgba(96, 125, 139, 0.22) 4px
  ) !important;
}
`;
